import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useHistory } from 'react-router';
import theme from '../../../styles/theme';
import { useUserContext } from '../../../contexts/UserContext';

import { Spacer, Anchor, Divider } from '../../atoms';
import TextField from '../TextField';

const OnlyTablet = styled.div`
  display: none;

  ${theme.mediaQuery('tablet')} {
    display: block;
  }
`;

const Nav = ({ links, ...props }) => {
  const history = useHistory();
  const { handleLogOut } = useUserContext();

  const submitLogOut = async () => {
    await handleLogOut();

    history.push('/login');
  };

  return (
    <Spacer {...props} size={theme.spacing.s} align="vertical">
      <OnlyTablet>
        <form>
          <TextField
            size="sm"
            placeholder="검색어를 입력하세요"
            name="search"
            iconName="search"
            width="200px"
            style={{ paddingBottom: theme.spacing.s }}
          />
        </form>
      </OnlyTablet>
      {links.map(({ name, to, text, onClick = () => {} }) => (
        <Anchor key={name} to={to} onClick={onClick}>
          {text}
        </Anchor>
      ))}
      <OnlyTablet>
        <Divider />
        <Spacer {...props} size={theme.spacing.s} align="vertical">
          <Anchor key="settings" to="/settings" exact>
            설정
          </Anchor>
          <Anchor key="logout" to="/login" onClick={submitLogOut} exact>
            로그아웃
          </Anchor>
        </Spacer>
      </OnlyTablet>
    </Spacer>
  );
};

Nav.propTypes = {
  links: PropTypes.array.isRequired,
  style: PropTypes.object,
};

Nav.defaultProps = {
  style: {},
};

export default Nav;
